<template>
  <div>
    <template>
      <v-card class="mx-auto" >
        <v-toolbar color="primary" dark>
                <v-toolbar-title>{{ formTitle }}</v-toolbar-title>
                   <v-spacer></v-spacer>
                   <v-btn color="white black--text " @click="close">
              close
            </v-btn> 
           </v-toolbar>
      </v-card>
  </template>      
    <v-card>
    
     <v-container class="fixWidth">
       <v-form ref="formVal" lazy-validation>
            <v-row>
               <v-col
                cols="12"
                sm="6"
                md="6"
                class="mt-2"
              >
                <v-text-field
                  v-model="getSchema.order_no"
                  required
                  :rules="generalRules.concat(numberRule)"
                >
                <template v-slot:label>
                  Order No<strong style="color: red">*</strong>
                </template>
                </v-text-field>
                
              </v-col>
              <v-col
                cols="12"
                sm="6"
                md="6"
                class="mt-2"
              >
                <v-text-field
                  v-model="getSchema.question"
                  required
                  :rules="generalRules"
                >
                <template v-slot:label>
                  Question<strong style="color: red">*</strong>
                </template>
                </v-text-field>
              </v-col>
              <v-col
                cols="12"
                sm="12"
                md="12"
              >
                <label>Answer</label>
                <span v-if="vueEditorValidation.handler">{{vueEditorValidation.message}}</span>
                <vue-editor v-model="getSchema.answer" @input="vueEditorValAct('vue-editor')"></vue-editor>
              </v-col>
            </v-row>
          </v-form>
          </v-container>
      <v-divider></v-divider>
      <template>
        <div class="text-center" v-if="getLoaderStatus">
          <v-progress-circular
            indeterminate
            color="primary"
          ></v-progress-circular>
        </div>
      </template>
      <v-card-actions>
        <v-layout justify-center>
           <v-btn color="primary  white--text" @click.stop.prevent="validateBefore()"
            >{{buttonTitle}}</v-btn
          >
          
          <span></span>
          <v-btn color="red  white--text" @click="clear">Reset</v-btn>
        </v-layout>
      </v-card-actions>
    </v-card>
    
  </div>
</template>

<script>
import { VueEditor, Quill } from "vue2-editor";

export default {
  
  components: {
    VueEditor,
    Quill
  },
  props: ["dialogStatus", "editedData","indexEdited"],
  data: () => ({
    
    loading: false,
    dialog: false,
    progressShow:false,
    generalRules: [
      v => !!v || "This field is required",
    ],
    numberRule: [
      v => /^\d+$/.test(v) || "This field can only have numbers"
    ],
    vueEditorValidation: {
      handler: false,
      message: ""
    },
    customToolbar: [
      ["bold", "italic", "underline"], 
      [{ list: "ordered" }, { list: "bullet" }],
      [{ align: "" }, { align: "center" }, { align: "right"}, { align: "justify"}],
      [{ color: ["black", "red", "blue", "yellow"] }],
      ["code-block"]
    ],

  }),
  created() {},
  mounted() {
   
  },
  watch: {
    dialogStatus(val) {
     //  console.log("val sdsd",val);
      this.dialog = val;
      this.$store.commit("SET_FAQ_SCHEMA", this.editedData);
      
     
    },
    dialog(val) {
      if (!val) this.close();
    },
  },
  computed: {
    getFaqItem() {
      return this.$store.getters.getFaqItem;
    },
    getSchema() {
      return this.$store.getters.getFaqSchema;
    },
    
    buttonTitle() {
      return this.indexEdited === -1 ? "Save" : "Update";
    },
    formTitle() {
      return this.indexEdited === -1
        ? "Create New FAQ"
        : "Update New FAQ ";
    },
    getLoaderStatus(){
      return this.$store.getters.getLoaderStatus;
    }
  },
  methods: {
    vueEditorValAct(val){
      if(val=='vue-editor'){
        if(this.getSchema.answer==""){
          this.vueEditorValidation.message="this field is required";
          this.vueEditorValidation.handler=true;
        }else{
          this.vueEditorValidation.handler=false;
        }
      }
    },
     validateBefore() {
       this.vueEditorValAct('vue-editor');
      let valid = this.$refs.formVal.validate()
      if(valid && !this.vueEditorValidation.handler){
        this.validationForm();
      }
    },
   save() {
      let self = this;
      // this.progressShow = true;
      let item =this.getSchema;
      this.$store
        .dispatch("saveFaqData", item)
        .then(function (data) {
          // self.progressShow = false;
          try {
            this.close();
            self.$emit("callReget", true);
          } catch (ex) {
           //  console.log(ex);
          }
        })
        .catch(function () {
        });
      
    },
    edit() {
      let self = this;
      let item =this.getSchema;
      this.$store
        .dispatch("editFaqData", item)
        .then(function(data) {
          
          this.close();
          self.$emit("update:loadData", true);
          self.$emit("callReget", false);
        })
        .catch(function(error) {
         //  console.log(error);
          
        });
      this.$emit('saveText', -1);
    },
   
    close() {
      this.questionSelect = true;
      this.$store.commit("SET_LOADER", false);
      this.$emit("update:dialogStatus", false);
      setTimeout(() => {
        this.$emit("update:indexEdited", -1);
      }, 300);
      this.clear();
    },
 
    validationForm() {
      
          return this.indexEdited === -1 ? this.save() : this.edit();
     
    },
    clear() {
      
      this.getSchema.order_no = "";
      this.getSchema.question = "";
      this.getSchema.answer = "";
      this.$refs.formVal.reset();
    },
  },
};
</script>
<style scoped>
.v-progress-circular {
  margin: 1rem;
}
.fixWidth{
  width: auto;
}
</style>
